import { ItemCardWithPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithPieces/ItemCardWithPieces";
import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndTypeWithOrderedDetails } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { FixaQuantityStepper } from "@coworker/apprestructured/src/shared/wrappers/FixaQuantityStepper/FixaQuantityStepper";
import React from "react";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

interface ArticlesQuantityContentProps {
  itemsWithPieces: ItemWithPieces[];
  itemsNoAndTypeOrderedDetails:
    | ItemNoAndTypeWithOrderedDetails[]
    | null
    | Loading;
  handlePiecesChange: (itemNo: string, newPieces: number) => void;
}

export const ArticlesQuantityContent = ({
  itemsWithPieces,
  itemsNoAndTypeOrderedDetails,
  handlePiecesChange,
}: ArticlesQuantityContentProps) => {
  const piecesByItemNo = new Map(
    Array.isArray(itemsNoAndTypeOrderedDetails)
      ? itemsNoAndTypeOrderedDetails.map(({ no, pieces, pieces_ordered }) => [
          no,
          { pieces, pieces_ordered },
        ])
      : []
  );

  return (
    <>
      {itemsWithPieces.map((item) => (
        <React.Fragment key={item.no}>
          <ItemCardWithPieces item={item} />
          <FixaQuantityStepper
            small
            fluid
            defaultValue={
              piecesByItemNo.get(item.no)?.pieces_ordered ??
              piecesByItemNo.get(item.no)?.pieces ??
              0
            }
            ariaDescribedById={`item-pieces-quantity-stepper-${item.no}`}
            ariaDescribedBy={`quantity-stepper-${item.no}`}
            minVal={1}
            maxVal={piecesByItemNo.get(item.no)?.pieces ?? 0}
            onQuantityChange={(newQuantity) =>
              handlePiecesChange(item.no, Number(newQuantity))
            }
          />
        </React.Fragment>
      ))}
    </>
  );
};
